<ng-container *ngIf="shouldShowDisabledPage(); else appContent">
  <app-app-disabled />
</ng-container>

<ng-template #appContent>
  <app-header [title]="title" />
  <app-spinner></app-spinner>
  <router-outlet />
  <app-shared />
  <app-cookie-consent-modal />
  <app-important-notification-modal />
  <app-footer [title]="title" />
  <app-document-viewer></app-document-viewer>
</ng-template>

<div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 11">
  <ng-template #toastContainer></ng-template>
</div>
